module.exports = __webpack_public_path__ + "static/media/placeholder-5.1f118aef.jpg";